<script context="module">
  import monoFontUrl from "../assets/fonts/BerkeleyMono-Regular.woff2";
  import characterFontUrl from "../assets/fonts/Hershey-Noailles-Futura-Simplex-Regular.woff2";
  import { settings, sketch } from "../util/punched-card.js";

  // Annoying bug on iOS:
  // When you visit the library first (without loading card)
  // and then click Export History, and cancel the interaction, and then go to Data tab,
  // the font loader never resolves, and hangs forever. The only way to fix is to load fonts upfront
  // at module resolution time... bonkers!
  const canvasResolution = 1920;
  const aspect = settings.dimensions[0] / settings.dimensions[1];
  let width = Math.round(canvasResolution);
  let height = Math.round(canvasResolution / aspect);

  let background = undefined;
  const manager = sketch({
    width,
    height,
    data: {
      characterFontUrl,
      background,
      monoFontUrl,
      cacheBackground: true,
    },
  });

  let isLoaded = false;
  let loadPromise = manager.load().then(() => {
    isLoaded = true;
  });
</script>

<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { createEmptyEncoding } from "bitframes";

  export let encoding = createEmptyEncoding();
  export let clickable = false;

  let context, canvas;

  let viewWidth;
  let viewHeight;
  let container;

  // let loaded = false;

  $: {
    manager.setEncoding(encoding);
    if (context && isLoaded) draw();
  }

  const dispatch = createEventDispatcher();
  onMount(() => {
    const observer = new ResizeObserver((entries) => {
      resize(entries[0].contentRect);
    });
    resize(container.getBoundingClientRect());
    observer.observe(container);

    context = canvas.getContext("2d");
    if (isLoaded) {
      draw();
    } else {
      loadPromise.then(() => draw());
    }

    return () => {
      observer.unobserve(container);
    };
  });

  function resize(contentRect) {
    const parentSize = contentRect;
    const dim = parentSize.width;
    // viewWidth = `${dim}px`;
    // viewHeight = `${Math.round(dim / aspect)}px`;

    viewWidth = `100%`;
    viewHeight = `auto`;
  }

  function draw() {
    if (!context) return;
    manager.render({
      context,
      width,
      height,
    });
  }
</script>

<div class="container" bind:this={container}>
  <canvas
    on:click={(ev) => {
      ev.preventDefault();
      dispatch("click");
    }}
    class:clickable
    bind:this={canvas}
    {width}
    {height}
    style={`width: ${viewWidth}; height: ${viewHeight};`}
  ></canvas>
</div>

<style>
  .container {
    /* max-width: 650px; */
    overflow: hidden;
    display: flex;
    /* justify-content: flex-end; */
    /* align-items: flex-end; */
    flex-grow: 1;
    width: 100%;
    height: 100%;
    /* background: pink; */
  }
  .clickable {
    cursor: pointer;
  }
  canvas {
    /* cursor: pointer; */
    /* transform-origin: 0% 0%; */
    /* transform: translate(50%, 0) rotate(90deg); */
    /* cursor: pointer; */
  }
</style>
